import { render, staticRenderFns } from "./IconMenu.vue?vue&type=template&id=25dc5069"
import script from "./IconMenu.vue?vue&type=script&lang=ts"
export * from "./IconMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports